import { ImmortalStorage, CookieStore, LocalStorageStore } from 'immortal-db';
import {LOGIN_DATA} from "../services/AuthService";
import {LOGOUT} from "../services/AuthService";


const stores = [CookieStore, LocalStorageStore];
const db = new ImmortalStorage(stores);

/* ---------- --------- ----------- */
/* ---------- Constants ----------- */
/* ---------- --------- ----------- */
export const appConstants = {
    SET_LOGIN_DATA:'SET_LOGIN_DATA',
    LOGOUT:'LOGOUT',
};




/* -------- --------- -------- */
/* --------  Action  ----------- */
/* -------- --------- -------- */
export function appSetLoginData(token,data)
{
     //TODO: STORE TOKEN by : cookie.setCookie('JWT_TOKEN',token);
    db.set(LOGIN_DATA, token);
    return { type: appConstants.SET_LOGIN_DATA, token:token,data:data}
}



/* -------- --------- -------- */
/* --------  Action  ----------- */
/* -------- --------- -------- */
export function logout() {
    //TODO: STORE TOKEN by : cookie.removeCookie('JWT_TOKEN');
    db.remove(LOGIN_DATA);
    return { type: appConstants.LOGOUT }
}

